import container from '../container/container';

interface JumpToOptionsInterface {
	modifier?: number,
	easing?: string,
	speed?: number
}

interface CenterToOptionsInterface {
	speed?: number,
	modifier?: number,
	easing?: string,
	stripAdjust?: boolean
}

const jump = function (id: number) {

	const privateVars = {
		name: 'jump(' + id + ')',
	};

	const privateMethods = {
		prepareObj: function () {
			privateMethods.startup();
			privateMethods.bind();
		},
		startup: function () {

		},
		bind: function () {
			container.msg(privateVars.name, 'module started');
		},

		animateScrollTo: function (targetPosition: number, duration: number, easing: string, callback: () => void) {

			const start = window.scrollY;
			const startTime = performance.now();

			function scroll() {
				const currentTime = performance.now();
				const timeElapsed = currentTime - startTime;
				const progress = Math.min(timeElapsed / duration, 1);
				const ease = easingFunction(progress);

				window.scrollTo(0, start + (targetPosition - start) * ease);

				if (timeElapsed < duration) {
					requestAnimationFrame(scroll);
				} else if (typeof callback === 'function') {
					callback();
				}
			}

			function easingFunction(t: number) {
				switch (easing) {
					case 'linear':
						return t;
					case 'easeInOutExpo':
						if(t===0) return 0;
						if(t===1) return 1;
						if((t/=0.5) < 1) return 0.5 * Math.pow(2,10 * (t-1));
						return 0.5 * (-Math.pow(2, -10 * --t) + 2);

						//
						// return t === 0 ? 0 :
						// 	t === 1 ? 1 : t < 0.5 ? Math.pow(2, 20 * t - 10) / 2 : (2 - Math.pow(2, -20 * t + 10)) / 2;
					default:
						return t;
				}
			}

			requestAnimationFrame(scroll);
		},

		jumpTo: function (handler: string, options: JumpToOptionsInterface, callback: () => void) {
			let state = 0;
			options = options || {};

			const targetHtml = document.querySelector(handler);

			if(!targetHtml) {
				console.error('Element not found:', handler);
				return;
			}

			const topPos = targetHtml.getBoundingClientRect().top + window.scrollY;

			const modifier = options.modifier || 0;
			const easing = options.easing || 'linear';
			const speed = options.speed !== undefined ? options.speed : 800;

			privateMethods.animateScrollTo((topPos + modifier), speed, easing, function () {

				if (state == 0) {
					state = 1;

					if (typeof callback === 'function') {
						callback();
					}
				}

			});
		},
		centerTo: function (handler: string, options: CenterToOptionsInterface, callback: () => void) {
			options = options || {};

			const targetHtml = document.querySelector(handler) as HTMLElement;

			if(!targetHtml) {
				console.error('Element not found:', handler);
				return;
			}

			const offsetTop = targetHtml.getBoundingClientRect().top + window.scrollY;
			const speed = options.speed !== undefined ? options.speed : 200;
			const modifier = options.modifier || 0;
			const easing = options.easing || 'linear';

			let windowHeight = window.innerHeight;
			let windowHeightModified = windowHeight;

			if (modifier !== 0) {
				windowHeightModified = windowHeight + modifier;
			}

			let adjustment;

			if (options.stripAdjust) {
				adjustment = (windowHeightModified - targetHtml.offsetHeight) / 2;
			} else {
				adjustment = Math.max(0, (windowHeightModified - targetHtml.offsetHeight) / 2);
			}

			if (modifier && !adjustment) {
				adjustment = -modifier;
			} else if (modifier) {
				adjustment = adjustment - (modifier);
			}

			const scrollTop = offsetTop - adjustment;

			if (speed == 0) {
				window.scrollTo(0, scrollTop);

				if (typeof callback === 'function') {
					callback();
				}
			} else {
				let state = 0;

				privateMethods.animateScrollTo(scrollTop, speed, easing, function () {
					if (state == 0) {
						state = 1;

						if (typeof callback === 'function') {
							callback();
						}
					}
				});
			}

		}
	};

	return {
		init: function () {
			privateMethods.prepareObj();
		},
		jumpTo: function (handler: string, options: JumpToOptionsInterface, callback: () => void) {
			privateMethods.jumpTo(handler, options, callback);
		},
		centerTo: function (handler: string, options: CenterToOptionsInterface, callback: () => void) {
			privateMethods.centerTo(handler, options, callback);
		}

	};
};

const Factory = {
	objId: 0,
	/**
	 * Get new preloader object
	 *
	 * @returns preloader
	 */
	create: function () {
		Factory.objId++;

		return jump(Factory.objId);
	}
};

export default {
	create: Factory.create
};


/*
 ---
 var jump = jumpFactory.create();
 ---
 jump.jumpTo(view.publicVars.cssId.homeQuestionTop, function() {});
 ---
 jump.centerTo(view.publicVars.cssId.homeQuestionTop, function() {});
 ---
 */